import { PayloadAction } from '@reduxjs/toolkit'
import { EReportColumnHeader } from '@unfoldrtech/portal-mic'

import { TDOOHLocationsReportTableFilters } from '../../../models'

const setSortByV3 = (
  state: TDOOHLocationsReportTableFilters,
  action: PayloadAction<{
    sortBy?: EReportColumnHeader
  }>
) => {
  state.sortBy = action.payload.sortBy
}

export default setSortByV3
